import { FtlRouteViewModel } from "../../../../ViewModel/FtlRouteViewModel";
import { isRoutingTableChanged } from "./IsRoutingTableChanged";
import { isSpdrOrPdsrChanged } from "./IsSpdrOrPdsrChanged";
import { getNPDS } from "./GetNPDS";
import { PdsrClientViewModel } from "../../../../ViewModel/PdsrClientViewModel";

export function areRoutesChangedPdsr(
  selectedPdsrId: number | undefined,
  ftlRoutes: Array<FtlRouteViewModel> | undefined,
  templateFtlRoutes: Array<FtlRouteViewModel> | undefined
) {
  if (!selectedPdsrId || !ftlRoutes || !templateFtlRoutes) {
    return false;
  }

  const { network, plant, dock, supplier } = getNPDS(selectedPdsrId, ftlRoutes);

  const ftlRoutesWithSelectedPdsr = ftlRoutes.filter((r) =>
    r.PdsrsOnThisRoute?.filter((p) => p.PdsrId === selectedPdsrId)
  );

  const templateFtlRoutesWithSelectedPdsr = templateFtlRoutes.filter((r) =>
    r.PdsrsOnThisRoute?.filter(
      (p) =>
        p.ContainerNetwork === network &&
        p.PlantGsdb === plant &&
        p.DockCode === dock &&
        p.SupplierGsdb === supplier
    )
  );

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < ftlRoutesWithSelectedPdsr.length; i++) {
    const templateRouteWithPdsr = templateFtlRoutesWithSelectedPdsr.find(
      (r) => r.RouteNumber === ftlRoutesWithSelectedPdsr[i].RouteNumber
    );

    const templatePdsr: PdsrClientViewModel | undefined =
      templateRouteWithPdsr?.PdsrsOnThisRoute?.find(
        (p) =>
          p.ContainerNetwork === network &&
          p.PlantGsdb === plant &&
          p.DockCode === dock &&
          p.SupplierGsdb === supplier
      );

    const pdsr: PdsrClientViewModel | undefined = ftlRoutesWithSelectedPdsr[
      i
    ]?.PdsrsOnThisRoute?.find((p) => p.PdsrId === selectedPdsrId);

    if (!templatePdsr || !pdsr) {
      return true;
    }

    if (
      isSpdrOrPdsrChanged(templatePdsr, pdsr) ||
      isRoutingTableChanged(
        templateRouteWithPdsr?.RoutingTable,
        ftlRoutesWithSelectedPdsr[i].RoutingTable
      )
    ) {
      return true;
    }
  }

  return false;
}
